<template>
  <span
    v-if="country"
    :class="country.iso2.toLowerCase()"
    class="v3q_tel__flag"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { countries, Country } from './countries';

export default defineComponent({
  props: {
    dialCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    countries(): Country[] {
      return countries.filter(c => c.dialCode === this.dialCode);
    },
    country(): Country|null {
      return this.countries.length === 1 ? this.countries[0] : null;
    },
  },
});
</script>
